import countriesAndTimezones from "countries-and-timezones";

export const getTimezoneCountryISO = () => {
	const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
	const timezoneInfo = countriesAndTimezones.getTimezone(timezone);
	return timezoneInfo.countries[0] || "US";
};
